import React from "react";

const Loading = () => {
  return (
    <div className="loading p-absolute">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
